/*
 * Lore-scroll overlay wiring (user request): the two embedded iframes on
 * #screen-scroll — a looping YouTube short and the Google Form guest log. Kept
 * out of screens.js so that file stays a pure show/hide controller.
 *
 * `Game` drives the scroll's visibility through GameState.SCROLL; this module
 * only manages the iframes. Both ship with no `src` and a `data-src`, so
 * nothing off-site loads until the player first opens the scroll.
 *
 *   - video: autoplays muted and loops on every open, blanked on close. Sound
 *     is off by default (user request); the embedded player's own controls
 *     (an unmute prompt plus the mute toggle in its control bar) turn it on.
 *   - guest form: loaded once and left mounted, so a half-typed message
 *     survives closing and re-opening the scroll.
 */

const el = (id) => document.getElementById(id);

const BLANK = "about:blank";
let _formMounted = false;

/** Scroll opened: (re)start the looping video and mount the guest form once. */
export function startScrollMedia() {
  const video = el("scroll-video");
  if (video && video.dataset.src && video.getAttribute("src") !== video.dataset.src) {
    video.src = video.dataset.src;
  }

  const form = el("scroll-guestbook-form");
  if (form && !_formMounted && form.dataset.src) {
    form.src = form.dataset.src;
    _formMounted = true;
  }
}

/** Scroll closed: blank the video so playback, audio, and buffering all stop. */
export function stopScrollMedia() {
  const video = el("scroll-video");
  if (video && video.getAttribute("src") && video.getAttribute("src") !== BLANK) {
    video.src = BLANK;
  }
}
